export default {
  bind (el, bindings, vNode) {
    const { value } = bindings
    const threshold = 300 // px left to scroll
    let isBusy = false

    // Hacky place listener function in element to destroy event listener in unbind hook
    el.onScrollListener = () => {
      if (isBusy) return

      const delta = el.offsetTop + el.clientHeight  - (window.innerHeight + window.scrollY)

      if (delta > threshold) return

      isBusy = true

      value()
        .finally(res => { isBusy = false })
    }

    document.addEventListener('scroll', el.onScrollListener)

    vNode.context.$bus.$once('lazy-load-end', () => {
      document.removeEventListener('scroll', el.onScrollListener)
    })
  },
  unbind (el) {
    document.removeEventListener('scroll', el.onScrollListener)
  }
}
